// extracted by mini-css-extract-plugin
module.exports = {"EmployerStatusPage":"Xli0K4qX","WelcomePage":"BcYOZAAP","title":"_1MTbE6MR"};
    if(module.hot) {
      // 1746735765566
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  